export const REFERENCE_PICKER_DISPLAY_VARIANTS = {
  LIST: 'List',
  ACCORDION: 'Accordion',
};
